/// <reference path="../_all.ts" />

module blog {
  'use strict';

  export class BerechnungCtrl {

    public static $inject = [
      '$scope',
      'pageMetaService',
    ];

    constructor(
      private $scope: IBerechnungCtrlScope,
      private pageMetaService: navigation.IPageMetaService
    ) {

      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;

      $scope.showHints = true;

      // Berechnungshilfe-Ozon

      $scope.messumfang = 300;
      $scope.schicht = 1;
      $scope.absorption = 1.761;
      $scope.druck = 101.3;

      $scope.druckEinheiten = [
        { name: "kPa", value: 1E3 },
        { name: "Pa", value: 1 },
        { name: "bar", value: 1E5 },
        { name: "at", value: 0.981E5 },
        { name: "mm W.S.", value: 9.81 },
        { name: "atm", value: 1.01E5 },
        { name: "Torr", value: 133 }
      ];

      $scope.temperatur = 20;

      $scope.temperaturEinheiten = [
        { name: "°C", value: "C" },
        { name: "°F", value: "F" },
        { name: "K", value: "K" }
      ];

      $scope.messumfangErgebnis = 300;

      $scope.currentPE = $scope.druckEinheiten[0];
      $scope.currentTE = $scope.temperaturEinheiten[0];

      // Berechnungshilfe-Hazen

      $scope.wavelengths = [
        { name: "365", value: 7.99 },
        { name: "390", value: 4.76 },
        { name: "400", value: 3.16 },
        { name: "410", value: 1.81 },
        { name: "420", value: 1.00 },
        { name: "430", value: 0.76 },
        { name: "436", value: 0.79 }
      ];

      $scope.wavelength = $scope.wavelengths[0];

      $scope.messumfangHazen = 200;
      $scope.schichtHazen = 50;
      $scope.absorptionHazen = 2.351;

    }

    // Berechnungshilfe-Ozon
    
    private ozon = {
      "c": 0.00587,
      "aK": new Array(1.0E9, 1020.0, 510.0, 255.0, 170.0, 127.0, 102.0, 51.0, 25.0, 17.0, 10.0, 5.0),
      "aS": new Array("Error", "0.5", "1", "2", "3", "4", "5", "10", "20", "30", "50", "100"),
      "oldPEVal": 1.0E3,
      "oldTE": { name: "°C", value: "C" },
      "p0": 101300.0,
      "p1": 101300.0,
      "t0": 293.0,
      "t1": 293.0
    }

    private tempConvert = {
      "CelsiusToKelvin": (t) => {
        return t + 273.15;
      },
      "FahrenheitToKelvin": (t) => {
        return (t + 459.67) / 1.8;
      },
      "KelvinToCelsius": (t) => {
        return t - 273.15;
      },
      "KelvinToFahrenheit": (t) => {
        return 1.8 * t - 459.67;
      }
    }

    BerechneSchicht() {
      var k = this.$scope.messumfang;
      var i = this.ozon['aK'].length - 1;
      while ((k > this.ozon['aK'][i]) && (i > 0)) { i-- };
      this.$scope.schicht = parseFloat(this.ozon['aS'][i]);
      var a = this.ozon['c'] * k * parseFloat(this.ozon['aS'][i]);
      this.$scope.absorption = (1000.0 * a + 0.5555) / 1000.0;
      this.BerechneNorm();
    }

    BerechneDruck() {
      this.$scope.druck = this.ozon['oldPEVal'] * this.$scope.druck / this.$scope.currentPE.value;
      this.ozon['oldPEVal'] = this.$scope.currentPE.value;
    }

    BerechneTemperatur() {
      var t = this.$scope.temperatur;
      if (this.ozon['oldTE'].value == "C") { t = this.tempConvert['CelsiusToKelvin'](t) } else
        if (this.ozon['oldTE'].value == "F") { t = this.tempConvert['FahrenheitToKelvin'](t) };
      if (this.$scope.currentTE.value == "C") { t = this.tempConvert['KelvinToCelsius'](t) } else
        if (this.$scope.currentTE.value == "F") { t = this.tempConvert['KelvinToFahrenheit'](t) };
      this.$scope.temperatur = Math.round(t);
      this.ozon['oldTE'] = this.$scope.currentTE;
    }

    SetzeNormbedingungen() {
      this.$scope.currentTE = this.$scope.temperaturEinheiten[0];
      this.$scope.currentPE = this.$scope.druckEinheiten[0];
      this.$scope.temperatur = 20;
      this.$scope.druck = 101.3;
      this.ozon['oldPEVal'] = 1E3;
      this.ozon['oldTE'] = { name: "°C", value: "C" };
      this.ozon['p0'] = 101300.0;
      this.ozon['t0'] = 293.0;
      this.BerechneNorm();
    }

    BerechneNorm() {
      var k0 = this.$scope.messumfang;
      var a = this.$scope.absorption;
      this.ozon['p1'] = this.ozon['oldPEVal'] * this.$scope.druck;
      this.ozon['t1'] = this.$scope.temperatur;
      if (this.ozon['oldTE'].value == "C") { this.ozon['t1'] = this.tempConvert['CelsiusToKelvin'](this.ozon['t1']); }
      if (this.ozon['oldTE'].value == "F") { this.ozon['t1'] = this.tempConvert['FahrenheitToKelvin'](this.ozon['t1']); }
      this.$scope.messumfangErgebnis = Math.round(k0 * (this.ozon['t1'] * this.ozon['p0']) / (this.ozon['t0'] * this.ozon['p1']));
    }

    // Berechnungshilfe-Hazen

    private hazen = {
      "c": 0.00002942,
      "aK": new Array(1.0E9, 203000.0, 101000.0, 50900.0, 33900.0, 25400.0, 20300.0, 10100.0, 5090.0, 3390.0, 2030.0, 1000.0),
      "aS": new Array("Error", "0.5", "1", "2", "3", "4", "5", "10", "20", "30", "50", "100")
    }

    BerechneSchichtHazen() {
      var w = this.$scope.wavelength.value;
      var k = this.$scope.messumfangHazen;
      k = k * w;
      var i = this.hazen['aK'].length - 1;
      while ((k > this.hazen['aK'][i]) && (i > 0)) { i-- };
      var s = parseFloat(this.hazen['aS'][i]);
      var a = this.hazen['c'] * k * parseFloat(this.hazen['aS'][i]);
      this.$scope.schichtHazen = s;
      this.$scope.absorptionHazen = Math.round(1000.0 * a) / 1000.0;
    }

  }
}